import { observer } from 'mobx-react-lite';
import CreateIntegrationConnection from './CreateIntegrationConnection';

function IntegrationSelectionPage() {
	return <CreateIntegrationConnection />;
}

const IntegrationSelectionPageObserver = observer(IntegrationSelectionPage);
export default IntegrationSelectionPageObserver;
